var _excluded = ["a11yTitle"],
  _excluded2 = ["size", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type"],
  _excluded3 = ["as"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["value", "placeholder", "label", "option", "render", "compact", "onChange", "onKeyUp", "onError", "onValid", "onValidation", "autofocus", "alt", "disabled", "validation", "type", "readOnly", "minLength", "maxLength", "max", "min", "step", "validateOnMount", "name", "autocomplete"],
  _excluded9 = ["isPasswordVisible", "onClick", "autocomplete"],
  _excluded10 = ["value", "label", "option", "compact", "autofocus", "className", "resizable"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsx as o, jsxs as f } from "react/jsx-runtime";
import { forwardRef as d, useState as T, useCallback as pe, useEffect as k } from "react";
import { styled as i, css as c, createGlobalStyle as be } from "styled-components";
var ue = function ue(e) {
    return !!e && !!e && /^[\w\-+.]+@([\w-]+\.)+[\w-]{2,3}$/.test(e);
  },
  fe = function fe(e) {
    if (e == null || e === "") return !1;
    var t = Number(e);
    return typeof e == "string" && t >= 0 && Number.isInteger(t);
  },
  F = i.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"]))),
  Z = i.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
  V = i.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"]))),
  D = i.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
  he = i(F)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"]))),
  ge = i.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]))),
  xe = i.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref) {
    var e = _ref.theme;
    return e.colors.red50;
  }),
  j = 8,
  A = c(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref2) {
    var e = _ref2.theme.down;
    return e("tablet");
  }),
  P = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  W = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  E = "0px 4px 28px rgba(0, 0, 0, 0.14)";
c(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], P);
c(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], W);
c(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], E);
c(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], P);
c(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], W);
c(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], E);
var me = function me(e, t) {
    return t in e.colors;
  },
  $e = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  ke = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
be(["", " img{max-width:100%;height:auto;object-fit:contain;}body{min-width:", ";}body,button,input{font-family:", ";color:", ";}p,a,h1,h2,h3,h4,h5,input,hr,button,section,menu{margin:0;padding:0;}div,section,input,button{box-sizing:border-box;}input{outline:none;}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{transition:background-color 100s ease-in-out 0s;}button{border:none;}"], ke, $e.phoneSm, function (_ref3) {
  var e = _ref3.theme;
  return e.fontFamily;
}, function (_ref4) {
  var e = _ref4.theme;
  return e.colors.black10;
});
var Ce = c(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref5) {
    var _t$colors$n;
    var e = _ref5.color,
      t = _ref5.theme,
      n = _ref5.disabled;
    var r;
    return n ? r = typeof n == "string" ? (_t$colors$n = t.colors[n]) !== null && _t$colors$n !== void 0 ? _t$colors$n : n : t.colors.black80 : e && me(t, e) ? r = t.colors[e] : r = e || t.colors.icon, c(["fill:", ";stroke:", ";"], r, r);
  }),
  C = 24,
  we = function we(e) {
    var t = e.match(/\d+(\.\d+)?/);
    return t ? parseFloat(t[0]) : C;
  },
  ve = i.svg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref6) {
    var _ref6$size = _ref6.size,
      e = _ref6$size === void 0 ? C : _ref6$size,
      t = _ref6.theme,
      n = _ref6.viewBox;
    var _split = (n || "0 0 ".concat(C, " ").concat(C)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      r = _split2[2],
      l = _split2[3],
      a = +r / +l,
      s = we(t.icons.size[e] || "".concat(e, "px"));
    return r < l ? "\n      width: ".concat(s, "px;\n      height: ").concat(s / a, "px;\n    ") : l < r ? "\n      width: ".concat(s * a, "px;\n      height: ").concat(s, "px;\n    ") : "\n      width: ".concat(s, "px;\n      height: ").concat(s, "px;\n    ");
  }, function (_ref7) {
    var e = _ref7.$hasOwnColorPattern;
    return e ? void 0 : Ce;
  }),
  L = function L(_ref8) {
    var e = _ref8.a11yTitle,
      t = _objectWithoutProperties(_ref8, _excluded);
    return /* @__PURE__ */o(ve, _objectSpread(_objectSpread({}, t), {}, {
      name: e
    }));
  },
  G = function G(e) {
    return /* @__PURE__ */o(L, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "VisibilityOff"
    }, e), {}, {
      children: /* @__PURE__ */o("path", {
        d: "M12 6.5C14.76 6.5 17 8.74 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.11 17 4 12 4C10.73 4 9.51 4.2 8.36 4.57L10.53 6.74C11 6.6 11.49 6.5 12 6.5ZM2.71 3.16C2.32 3.55 2.32 4.18 2.71 4.57L4.68 6.54C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.16C3.74 2.77 3.1 2.77 2.71 3.16ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 10 7.49 9.36L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.77 13.72 8.68 12.33 8.53L14.97 11.17Z",
        fill: "#0091DF"
      })
    }));
  };
G.displayName = "VisibilityOff";
var R = function R(e) {
  return /* @__PURE__ */o(L, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "VisibilityOn"
  }, e), {}, {
    children: /* @__PURE__ */o("path", {
      d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z",
      fill: "#0091DF"
    })
  }));
};
R.displayName = "VisibilityOn";
var U = function U(e) {
  return /* @__PURE__ */o(L, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Warning"
  }, e), {}, {
    children: /* @__PURE__ */o("path", {
      d: "M3.49492 22.105H20.5052C22.2446 22.105 23.3289 20.2187 22.4592 18.7165L13.9541 4.0217C13.0844 2.51947 10.9157 2.51947 10.046 4.0217L1.54089 18.7165C0.671174 20.2187 1.75549 22.105 3.49492 22.105ZM12.0001 15.1985C11.3788 15.1985 10.8706 14.6902 10.8706 14.069V9.81C10.8706 9.18877 11.3788 8.6805 12.0001 8.6805C12.6213 8.6805 13.1296 9.18877 13.1296 9.81V14.069C13.1296 14.6902 12.6213 15.1985 12.0001 15.1985ZM13.1296 17.587C13.1296 18.2108 12.6239 18.7165 12.0001 18.7165C11.3763 18.7165 10.8706 18.2108 10.8706 17.587C10.8706 16.9632 11.3763 16.4575 12.0001 16.4575C12.6239 16.4575 13.1296 16.9632 13.1296 17.587Z",
      fill: "#0091DF"
    })
  }));
};
U.displayName = "Warning";
function H(e) {
  return (e == null ? void 0 : e.text) !== void 0;
}
var M = {
    xLarge: "\n    padding: 16px 40px;\n    font-size: 20px;\n    line-height: 32px;\n  ",
    large: "\n    padding: 16px 30px;\n    font-size: 18px;\n    line-height: 24px;\n  ",
    medium: "\n    padding: 12px 22px;\n    font-size: 16px;\n    line-height: 24px;\n  ",
    small: "\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 24px;\n  ",
    xSmall: "\n    padding: 8px 16px;\n    font-size: 12px;\n    line-height: 16px;\n  "
  },
  ye = c(["&&{background:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:", ";text-decoration:none;}}}"], function (_ref9) {
    var e = _ref9.theme;
    return e.colors.black80;
  }, function (_ref10) {
    var e = _ref10.theme;
    return e.colors.black80;
  }),
  ze = i.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  outline: none;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n  height: fit-content;\n  font-family: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref11) {
    var e = _ref11.theme;
    return e.colors.black100;
  }, function (_ref12) {
    var _M$e;
    var e = _ref12.size;
    return (_M$e = M[e]) !== null && _M$e !== void 0 ? _M$e : M.small;
  }, function (_ref13) {
    var e = _ref13.disabled;
    return e && ye;
  }, function (_ref14) {
    var e = _ref14.$fit;
    return e && c(["width:fit-content;height:fit-content;"]);
  }),
  Te = i.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), function (_ref15) {
    var e = _ref15.$margin,
      t = _ref15.$position;
    return t === "left" ? 0 : "".concat(e, "px");
  }, function (_ref16) {
    var e = _ref16.$margin,
      t = _ref16.$position;
    return t === "right" ? 0 : "".concat(e, "px");
  }),
  N = function N(_ref17) {
    var e = _ref17.position,
      t = _ref17.Icon,
      n = _ref17.size;
    var r = Fe[n],
      l = ["small", "xSmall"].includes(n) ? 4 : 8;
    return t ? /* @__PURE__ */o(Te, {
      $position: e,
      $margin: l,
      children: /* @__PURE__ */o(t, {
        size: r
      })
    }) : null;
  },
  p = /*#__PURE__*/d(function (_ref18, z) {
    var _ref18$size = _ref18.size,
      e = _ref18$size === void 0 ? "medium" : _ref18$size,
      _ref18$disabled = _ref18.disabled,
      t = _ref18$disabled === void 0 ? !1 : _ref18$disabled,
      n = _ref18.onClick,
      r = _ref18.children,
      l = _ref18.LeftIcon,
      a = _ref18.RightIcon,
      s = _ref18.tabIndex,
      _ref18$fit = _ref18.fit,
      m = _ref18$fit === void 0 ? !1 : _ref18$fit,
      b = _ref18.name,
      u = _ref18.value,
      h = _ref18.className,
      _ref18$type = _ref18.type,
      v = _ref18$type === void 0 ? "button" : _ref18$type,
      y = _objectWithoutProperties(_ref18, _excluded2);
    return /* @__PURE__ */f(ze, _objectSpread(_objectSpread({
      size: e,
      disabled: t,
      onClick: n,
      tabIndex: s,
      $fit: m,
      name: b,
      value: u,
      className: h,
      type: v,
      ref: z
    }, y), {}, {
      children: [/* @__PURE__ */o(N, {
        Icon: l,
        size: e,
        position: "left"
      }), r, /* @__PURE__ */o(N, {
        Icon: a,
        size: e,
        position: "right"
      })]
    }));
  }),
  Fe = {
    xLarge: 32,
    large: 32,
    medium: 24,
    small: 16,
    xSmall: 16
  },
  Le = i(p)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref19) {
    var e = _ref19.theme;
    return e.colors.blue60;
  }, function (_ref20) {
    var e = _ref20.theme;
    return e.colors.blue50;
  });
/*#__PURE__*/d(function (_ref21, n) {
  var e = _ref21.as,
    t = _objectWithoutProperties(_ref21, _excluded3);
  return /* @__PURE__ */o(Le, _objectSpread({
    ref: n,
    forwardedAs: e
  }, t));
});
var Be = i(p)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref22) {
  var e = _ref22.theme;
  return e.colors.darkBlue40;
}, function (_ref23) {
  var e = _ref23.theme;
  return e.colors.darkBlue30;
});
/*#__PURE__*/d(function (e, t) {
  return /* @__PURE__ */o(Be, _objectSpread({
    ref: t
  }, e));
});
var Ie = i(p)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref24) {
  var e = _ref24.theme;
  return e.colors.purple40;
}, function (_ref25) {
  var e = _ref25.theme;
  return e.colors.purple30;
});
/*#__PURE__*/d(function (e, t) {
  return /* @__PURE__ */o(Ie, _objectSpread({
    ref: t
  }, e));
});
var Oe = c(["&&{pointer-events:none;background:transparent;color:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:transparent;}}& > svg{fill:", ";}}"], function (_ref26) {
    var e = _ref26.theme;
    return e.colors.black80;
  }, function (_ref27) {
    var e = _ref27.theme;
    return e.colors.black80;
  }),
  Se = i(p)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: transparent;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n  ", ";\n"])), function (_ref28) {
    var e = _ref28.theme;
    return e.colors.blue50;
  }, function (_ref29) {
    var e = _ref29.theme;
    return e.colors.blue30;
  }, function (_ref30) {
    var e = _ref30.theme;
    return e.colors.blue30;
  }, function (_ref31) {
    var e = _ref31.disabled;
    return e && Oe;
  }),
  Me = /*#__PURE__*/d(function (e, t) {
    return /* @__PURE__ */o(Se, _objectSpread({
      ref: t
    }, e));
  }),
  Ne = i(Me)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  Ze = /*#__PURE__*/d(function (e, t) {
    return /* @__PURE__ */o(Ne, _objectSpread({
      ref: t
    }, e));
  }),
  Ve = c(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref32) {
    var e = _ref32.theme;
    return e.colors.black80;
  }),
  De = i(p)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref33) {
    var e = _ref33.theme;
    return e.colors.blue60;
  }, function (_ref34) {
    var e = _ref34.theme;
    return e.colors.blue50;
  }, function (_ref35) {
    var e = _ref35.disabled;
    return e && Ve;
  }),
  je = /*#__PURE__*/d(function (_ref36, n) {
    var e = _ref36.children,
      t = _objectWithoutProperties(_ref36, _excluded4);
    return /* @__PURE__ */o(De, _objectSpread(_objectSpread({
      ref: n,
      "aria-label": "icon-button"
    }, t), {}, {
      children: e
    }));
  }),
  Ae = c(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref37) {
    var e = _ref37.theme;
    return e.colors.black80;
  }),
  Pe = i(p)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref38) {
    var e = _ref38.theme;
    return e.colors.darkBlue40;
  }, function (_ref39) {
    var e = _ref39.theme;
    return e.colors.darkBlue30;
  }, function (_ref40) {
    var e = _ref40.disabled;
    return e && Ae;
  });
/*#__PURE__*/d(function (_ref41, n) {
  var e = _ref41.children,
    t = _objectWithoutProperties(_ref41, _excluded5);
  return /* @__PURE__ */o(Pe, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
var We = c(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref42) {
    var e = _ref42.theme;
    return e.colors.black80;
  }),
  Ee = i(p)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref43) {
    var e = _ref43.theme;
    return e.colors.purple40;
  }, function (_ref44) {
    var e = _ref44.theme;
    return e.colors.purple30;
  }, function (_ref45) {
    var e = _ref45.disabled;
    return e && We;
  });
/*#__PURE__*/d(function (_ref46, n) {
  var e = _ref46.children,
    t = _objectWithoutProperties(_ref46, _excluded6);
  return /* @__PURE__ */o(Ee, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
var Ge = c(["&&{color:", ";&:hover{color:", ";}}"], function (_ref47) {
    var e = _ref47.theme;
    return e.colors.black100;
  }, function (_ref48) {
    var e = _ref48.theme;
    return e.colors.black100;
  }),
  Re = i(p)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      background: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref49) {
    var e = _ref49.theme;
    return e.colors.blue50;
  }, function (_ref50) {
    var e = _ref50.theme;
    return e.colors.blue95;
  }, function (_ref51) {
    var e = _ref51.theme;
    return e.colors.blue30;
  }, function (_ref52) {
    var e = _ref52.theme;
    return e.colors.blue90;
  }, function (_ref53) {
    var e = _ref53.disabled;
    return e && Ge;
  });
/*#__PURE__*/d(function (e, t) {
  return /* @__PURE__ */o(Re, _objectSpread({
    ref: t
  }, e));
});
var Ue = c(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref54) {
    var e = _ref54.theme;
    return e.colors.black80;
  }),
  He = i(p)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref55) {
    var e = _ref55.theme;
    return e.colors.blue95;
  }, function (_ref56) {
    var e = _ref56.theme;
    return e.colors.blue90;
  }, function (_ref57) {
    var e = _ref57.disabled;
    return e && Ue;
  });
/*#__PURE__*/d(function (_ref58, n) {
  var e = _ref58.children,
    t = _objectWithoutProperties(_ref58, _excluded7);
  return /* @__PURE__ */o(He, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
var K = i(Ze)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n  ", ";\n"])), function (_ref59) {
    var e = _ref59.theme,
      t = _ref59.$danger;
    return t && c(["color:", ";&:hover{color:", ";}@media (hover:none){&:hover{color:", ";}}"], e.colors.red60, e.colors.red40, function (_ref60) {
      var n = _ref60.theme;
      return n.colors.red60;
    });
  }),
  _ = c(["&,&:focus{border-color:", ";}&:focus-visible{border-color:", ";}"], function (_ref61) {
    var e = _ref61.theme;
    return e.colors.red60;
  }, function (_ref62) {
    var e = _ref62.theme;
    return e.colors.red60;
  }),
  q = i.input(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  outline: none;\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    border: 1px solid ", ";\n    user-select: none;\n  }\n\n  &[aria-invalid='true'] {\n    ", "\n  }\n\n  box-sizing: border-box;\n"])), j, function (_ref63) {
    var e = _ref63.theme;
    return e.colors.black100;
  }, function (_ref64) {
    var e = _ref64.theme;
    return e.colors.black60;
  }, A, function (_ref65) {
    var e = _ref65.theme;
    return e.colors.black60;
  }, function (_ref66) {
    var e = _ref66.theme;
    return e.colors.blue60;
  }, function (_ref67) {
    var e = _ref67.theme;
    return e.colors.blue60;
  }, function (_ref68) {
    var e = _ref68.theme;
    return e.colors.black95;
  }, function (_ref69) {
    var e = _ref69.theme;
    return e.colors.black60;
  }, _),
  Ke = i.textarea(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  resize: ", ";\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    outline: 0px;\n  }\n\n  &:focus-visible {\n    border-color: ", ";\n    outline: 0px;\n  }\n\n  &:disabled {\n    background: ", ";\n    border-color: ", ";\n    user-select: none;\n  }\n\n  &[aria-invalid='true'] {\n    ", "\n  }\n\n  box-sizing: border-box;\n"])), j, function (_ref70) {
    var e = _ref70.theme;
    return e.colors.black100;
  }, function (_ref71) {
    var e = _ref71.theme;
    return e.colors.black60;
  }, function (_ref72) {
    var e = _ref72.$resizable;
    return e ? "both" : "none";
  }, A, function (_ref73) {
    var e = _ref73.theme;
    return e.colors.black60;
  }, function (_ref74) {
    var e = _ref74.theme;
    return e.colors.blue60;
  }, function (_ref75) {
    var e = _ref75.theme;
    return e.colors.blue60;
  }, function (_ref76) {
    var e = _ref76.theme;
    return e.colors.black95;
  }, function (_ref77) {
    var e = _ref77.theme;
    return e.colors.black60;
  }, _),
  _e = i.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  qe = i(U).attrs({
    color: "red50"
  })(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n"]))),
  w = /*#__PURE__*/d(function (_ref78, le) {
    var _ref79;
    var e = _ref78.value,
      t = _ref78.placeholder,
      n = _ref78.label,
      r = _ref78.option,
      l = _ref78.render,
      a = _ref78.compact,
      s = _ref78.onChange,
      m = _ref78.onKeyUp,
      b = _ref78.onError,
      u = _ref78.onValid,
      h = _ref78.onValidation,
      v = _ref78.autofocus,
      y = _ref78.alt,
      z = _ref78.disabled,
      B = _ref78.validation,
      Q = _ref78.type,
      X = _ref78.readOnly,
      Y = _ref78.minLength,
      ee = _ref78.maxLength,
      te = _ref78.max,
      oe = _ref78.min,
      ne = _ref78.step,
      _ref78$validateOnMoun = _ref78.validateOnMount,
      I = _ref78$validateOnMoun === void 0 ? !0 : _ref78$validateOnMoun,
      ie = _ref78.name,
      re = _ref78.autocomplete,
      se = _objectWithoutProperties(_ref78, _excluded8);
    var _T = T(null),
      _T2 = _slicedToArray(_T, 2),
      g = _T2[0],
      ae = _T2[1],
      _T3 = T(!1),
      _T4 = _slicedToArray(_T3, 2),
      $ = _T4[0],
      O = _T4[1],
      ce = pe(function (de) {
        s == null || s(de), $ || O(!0);
      }, [$, s]);
    k(function () {
      (I || e) && (!I && e && console.warn("TextField: validation on mount is enabled, because value is defined"), O(!0));
    }, []), k(function () {
      $ && ae(Ye({
        value: e,
        validation: B
      }));
    }, [$, B, e]);
    var x = (g == null ? void 0 : g.isError) || !1;
    k(function () {
      x ? b == null || b() : u == null || u();
    }, [x, u, b]), k(function () {
      h == null || h(e, !x);
    }, [x, e, h]);
    var S = {
      placeholder: t,
      value: e,
      onChange: ce,
      onKeyUp: m,
      autoFocus: v,
      disabled: z,
      alt: y,
      "aria-invalid": x,
      "aria-label": typeof n == "string" ? n : void 0,
      type: Q,
      readOnly: X,
      minLength: Y,
      maxLength: ee,
      min: oe,
      max: te,
      step: ne,
      name: ie,
      autoComplete: re
    };
    return /* @__PURE__ */f(_e, _objectSpread(_objectSpread({}, se), {}, {
      children: [/* @__PURE__ */o(Xe, {
        label: n,
        option: r,
        compact: a
      }), (_ref79 = l == null ? void 0 : l(S)) !== null && _ref79 !== void 0 ? _ref79 : /* @__PURE__ */o(q, _objectSpread({
        ref: le
      }, S)), /* @__PURE__ */o(Je, {
        isError: x,
        errorText: g == null ? void 0 : g.errorText,
        compact: a
      })]
    }));
  });
w.displayName = "TextFieldBase";
var Je = function Je(_ref80) {
    var e = _ref80.errorText,
      t = _ref80.compact,
      n = _ref80.isError;
    return n && !!e || !t ? /* @__PURE__ */o(he, {
      children: n && /* @__PURE__ */f(ge, {
        children: [/* @__PURE__ */o(qe, {}), /* @__PURE__ */o(xe, {
          children: e
        })]
      })
    }) : null;
  },
  Qe = function Qe(e) {
    return H(e) ? {
      optionText: e.text,
      onOptionClick: e.onClick,
      optionDanger: e.danger
    } : {
      optionText: e
    };
  },
  Xe = function Xe(_ref81) {
    var e = _ref81.label,
      t = _ref81.option,
      n = _ref81.compact;
    if (!(e || t || !n)) return null;
    var _Qe = Qe(t),
      l = _Qe.optionText,
      a = _Qe.onOptionClick,
      s = _Qe.optionDanger;
    return /* @__PURE__ */f(F, {
      children: [/* @__PURE__ */o(Z, {
        children: e && /* @__PURE__ */o(V, {
          "data-testid": "label",
          "data-id": "label",
          children: e
        })
      }), /* @__PURE__ */o(D, {
        children: t && /* @__PURE__ */o(K, {
          onClick: a,
          "data-testid": "option",
          "data-id": "option",
          $danger: s,
          children: l
        })
      })]
    });
  },
  Ye = function Ye(_ref82) {
    var e = _ref82.value,
      t = _ref82.validation;
    if (!t || typeof e != "string" && e !== void 0) return;
    var n = Array.isArray(t) ? _toConsumableArray(t) : [t];
    for (var r = 0; r < n.length; r++) {
      var _n$r = n[r],
        l = _n$r.errorText,
        a = _n$r.validate;
      var s = !1;
      if (typeof a == "string" ? s = !et[a](e) : typeof a == "boolean" ? s = !a : s = !a(e), s) return {
        isError: s,
        errorText: l
      };
    }
  },
  et = {
    email: ue,
    positiveIntegerOrZero: fe
  },
  tt = /*#__PURE__*/d(function (e, t) {
    return /* @__PURE__ */o(w, _objectSpread({
      ref: t
    }, e));
  });
tt.displayName = "TextField";
var ot = /*#__PURE__*/d(function (e, t) {
  return /* @__PURE__ */o(w, _objectSpread(_objectSpread({}, e), {}, {
    ref: t,
    compact: !0
  }));
});
ot.displayName = "TextFieldCompact";
var nt = i(je)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 10px;\n"]))),
  it = i.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"]))),
  rt = i(w)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  & input {\n    padding-right: 40px;\n  }\n"]))),
  J = /*#__PURE__*/d(function (_ref83, l) {
    var e = _ref83.isPasswordVisible,
      t = _ref83.onClick,
      n = _ref83.autocomplete,
      r = _objectWithoutProperties(_ref83, _excluded9);
    return /* @__PURE__ */f(it, {
      children: [/* @__PURE__ */o(q, _objectSpread({
        ref: l,
        autoComplete: n
      }, r)), /* @__PURE__ */o(nt, {
        "data-testid": "toggler",
        onClick: function onClick() {
          return t(!e);
        },
        children: e ? /* @__PURE__ */o(R, {
          size: 16
        }) : /* @__PURE__ */o(G, {
          size: 16
        })
      })]
    });
  });
J.displayName = "InputWithToggler";
var st = /*#__PURE__*/d(function (e, t) {
  var _T5 = T(!1),
    _T6 = _slicedToArray(_T5, 2),
    n = _T6[0],
    r = _T6[1];
  return /* @__PURE__ */o(rt, _objectSpread(_objectSpread({}, e), {}, {
    "data-testid": "textbox-password",
    type: n ? "text" : "password",
    render: function render(l) {
      return /* @__PURE__ */o(J, _objectSpread({
        ref: t,
        isPasswordVisible: n,
        onClick: r
      }, l));
    }
  }));
});
st.displayName = "PasswordTextField";
var lt = i.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  at = /*#__PURE__*/d(function (_ref84, b) {
    var _ref84$value = _ref84.value,
      e = _ref84$value === void 0 ? "" : _ref84$value,
      t = _ref84.label,
      n = _ref84.option,
      r = _ref84.compact,
      l = _ref84.autofocus,
      a = _ref84.className,
      s = _ref84.resizable,
      m = _objectWithoutProperties(_ref84, _excluded10);
    return /* @__PURE__ */f(lt, {
      className: a,
      children: [/* @__PURE__ */o(dt, {
        label: t,
        option: n,
        compact: r
      }), /* @__PURE__ */o(Ke, _objectSpread({
        value: e,
        autoFocus: l,
        "aria-label": typeof t == "string" ? t : void 0,
        $resizable: s,
        ref: b
      }, m))]
    });
  });
at.displayName = "TextAreaField";
var ct = function ct(e) {
    return H(e) ? {
      optionText: e.text,
      onOptionClick: e.onClick,
      optionDanger: e.danger
    } : {
      optionText: e
    };
  },
  dt = function dt(_ref85) {
    var e = _ref85.label,
      t = _ref85.option,
      n = _ref85.compact;
    if (!(e || t || !n)) return null;
    var _ct = ct(t),
      l = _ct.optionText,
      a = _ct.onOptionClick,
      s = _ct.optionDanger;
    return /* @__PURE__ */f(F, {
      children: [/* @__PURE__ */o(Z, {
        children: e && /* @__PURE__ */o(V, {
          "data-testid": "label",
          "data-id": "label",
          children: e
        })
      }), /* @__PURE__ */o(D, {
        children: t && /* @__PURE__ */o(K, {
          onClick: a,
          "data-testid": "option",
          "data-id": "option",
          $danger: s,
          children: l
        })
      })]
    });
  };
export { st as PasswordTextField, at as TextAreaField, tt as TextField, ot as TextFieldCompact };